import * as React from 'react';
import * as PrintTemplate from 'react-print';
import { FormattedNumber } from 'react-intl';
import { Member } from './members.types';
import { getBusinessLogoUrl } from '../util/image.util';
import { BusinessState } from '../business/business.types';
import { PaymentInfo } from './members.types';
import { PaymentMethod } from '../billing/billing.const';
import './MembershipAgreementStyle.css';
import * as moment from 'moment';

const PAD_AGREEMENT_TITLE =
  'Pre-Authorized Debit Payor’s PAD Agreement - ​Terms & Conditions (Attach “VOID” Cheque)';
const CREDIT_CARD_AUTH_AGREEMENT = 'CREDIT CARD Authorization Agreement - Terms and Conditions';

type Props = {
  member: Member
  businessState: BusinessState
};

type States = {
  member: Member
};

class MembershipAgreementForm extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);

    this.state = {
      member: props.member
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props !== nextProps) {
      this.setState({
        member: nextProps.member
      });
    }
  }

  render() {
    const business = this.props.businessState.business ? this.props.businessState.business : undefined;
    const { member } = this.props;
    const payment = member.payments[0];

    if (business) {
      return(
        <PrintTemplate>
          <div className="container-fluid">
  
            <div className="row padding-zero-row pt-2 pl-2 pr-2 no-gutters">
              <div className="col-9 pl-2 pt-2">
                <div className="row no-gutters padding-zero-row">
                  <div className="d-inline-flex">
                    <img
                      src={getBusinessLogoUrl(business ? business.picUrl : '')}
                      style={{maxHeight: '4.0em'}}
                    />
                  </div>
                  <div className="col-10">
                    <div className="businessTitle">
                      <b>{business.name.toUpperCase()}</b>
                    </div>
                    <div style={{fontSize: '0.9em'}}>
                      <b>MEMBERSHIP AGREEMENT</b>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 businessAddress zero-six-em pr-3 pt-2">
                <div className="float-right">{business.address}</div> <br/>
                <div className="float-right">{business.city}, {business.province}</div> <br/>
                <div className="float-right">{business.postalCode.toUpperCase()}</div> <br/>
                <div className="float-right">Tel: {business.phone}</div><br/>
              </div>
            </div>
  
            <hr/>
  
            <div className="row pt-2 padding-top-zero pl-4">
              <div className="col-4 zero-eight-em font-weight-bold pl-2"> 1. Customer Information </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Member Name</div>
              <div
                className="col-6 black-border border-top-0 border-left-0 border-right-0 text-center"
                style={{fontSize: '1em'}}
              >
                {member.firstName} &nbsp; {member.lastName}
              </div>
              <div className="col-1 zero-six-em text-center">Birth Date</div>
              <div className="col-2 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {moment(new Date(member.birthDate)).format('MMM Do YY')}
              </div>
              <div className="col-1 zero-six-em text-center">Gender</div>
              <div className="col-1 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {member.gender}
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Payor Name</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.firstName : ''} &nbsp; {payment ? payment.payer.lastName : ''}
              </div>
              <div className="col-1 zero-six-em text-center">Cellphone 1</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.mobile1 : ''}
              </div>
              <div className="col-1 zero-six-em text-center">Cellphone 2</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.mobile2 : ''}
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Email</div>
              <div className="col-6 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                <div>{payment ? payment.payer.email : ''}</div>
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Payor Address</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.address : ''}
              </div>
              <div className="col-1 zero-six-em text-center">City</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.city : ''}
              </div>
              <div className="col-1 zero-six-em text-center">Postal Code</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {payment ? payment.payer.postalCode.toUpperCase() : ''}
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Start Date</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {moment(new Date(member.startDate)).format('MMM Do YY')}
              </div>
              <div className="col-1 zero-six-em text-center">End Date</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {moment(new Date(member.endDate)).format('MMM Do YY')}
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Contract Duration</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {member.contractDuration}
              </div>
              <div className="col-1 zero-six-em text-center">Receive Email?</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {member.emailConsent ? 'YES' : 'NO'}
              </div>
              <div className="col-1 zero-six-em text-center">Accept SMS Text?</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                {member.smsConsent ? 'YES' : 'NO'}
              </div>
            </div>
  
            <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
              <div className="col-1 zero-six-em text-center">Down Payment</div>
              <div className="col-3 zero-eight-em black-border border-top-0 border-left-0 border-right-0 text-center">
                <FormattedNumber value={payment ? payment.downPayment : ''} style="currency" currency="USD" />
              </div>
              <div className="col-1 zero-six-em text-center">Total Cost</div>
              <div className="col-3 zero-eight-em blue-border text-center">
                <FormattedNumber
                  value={ payment ?
                    payment.amountPerTransaction *
                    payment.numberOfTransactions +
                    payment.downPayment :
                    0
                  }
                  style="currency"
                  currency="USD"
                />
              </div>
            </div>
  
            {payment ? this.renderPaymentInfoSection(payment) : null}

            <div className="row pt-3 pl-4 pr-4">
              <div className="col-1 zero-six-em">Payor Name</div>
              <div
                className="col-4 black-border-transparent border-top-0 border-left-0 border-right-0 text-center"
              />
              <div className="col-1 zero-six-em">Signature</div>
              <div
                className="col-3 black-border-transparent border-top-0 border-left-0 border-right-0 text-center"
              />
              <div className="col-1 zero-six-em">Date</div>
              <div
                className="col-2 black-border-transparent border-top-0 border-left-0 border-right-0 text-center"
              />
            </div>

          </div>
        </PrintTemplate>
      );
    } else {
      return(<div/>);
    }
  }

  private renderPaymentInfoSection = (paymentInfo: PaymentInfo): JSX.Element => {
    if (paymentInfo.paymentMethod.paymentMethodType === PaymentMethod.VOIDCHEQUE) {
      return(
        <div>

          <div className="row pt-2 padding-top-zero pl-4">
            <div 
              className="col-12 zero-eight-em font-weight-bold pl-2"
            >
              2. Bank Account Information.&nbsp;
              <b className="blue">(Please circle one) &nbsp;&nbsp; PERSONAL &nbsp;&nbsp; or &nbsp;&nbsp; BUSINESS</b>
            </div>
          </div>
          <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
            <div className="col-12 black-border-transparent">
              <div className="row pa2">
                <div className="col-1 zero-six-em text-center">Transit#</div>
                <div
                  className="col-1 text-center zero-six-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.maskedTransitNumber}
                </div>
                <div className="col-1 zero-six-em text-center">Bank#</div>
                <div
                  className="col-1 text-center zero-six-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.financialInstitutionNumber}
                </div>
                <div className="col-1 zero-six-em text-center">Account#</div>
                <div
                  className="col-2 text-center zero-six-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.maskedBankAccountNumber}
                </div>
                <div className="col-2 zero-six-em text-center">Bank Name</div>
                <div
                  className="col-2 text-center zero-six-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.financialInstitutionName}
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-2 padding-top-zero pl-4">
            <div className="col-4 zero-eight-em font-weight-bold pl-2"> 3. Payment Schedule </div>
          </div>
          {this.renderPaymentSchedule(paymentInfo)}

          <div className="row pt-2 padding-top-zero pl-4">
            <div className="col-12 zero-eight-em font-weight-bold pl-2">
              4. {PAD_AGREEMENT_TITLE}
            </div>
          </div>
          {this.renderPadAgreement()}

        </div>
      );
    } else if (paymentInfo.paymentMethod.paymentMethodType === PaymentMethod.CREDITCARD) {
      return(
        <div>

          <div className="row pt-2 padding-top-zero pl-4">
            <div className="col-4 zero-eight-em font-weight-bold pl-2"> 2. Credit Card Information </div>
          </div>
          <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
            <div className="col-12 black-border-transparent">
              <div className="row pa2">
                <div className="col-1 text-center" style={{fontSize: '0.5em'}}>Card Number</div>
                <div
                  className="col-3 text-center zero-eight-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.cardNumber}
                </div>
                <div className="col-1 text-center" style={{fontSize: '0.5em'}}>Expiry Date</div>
                <div
                  className="col-3 text-center zero-eight-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.expiryMonth} / {paymentInfo.paymentMethod.expiryYear}
                </div>
                <div className="col-1 text-center" style={{fontSize: '0.5em'}}>CVC</div>
                <div
                  className="col-2 text-center zero-eight-em black-border border-top-0 border-left-0 border-right-0"
                >
                  {paymentInfo.paymentMethod.cvc}
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-2 padding-top-zero pl-4">
            <div className="col-4 zero-eight-em font-weight-bold pl-2"> 3. Payment Schedule </div>
          </div>
          {this.renderPaymentSchedule(paymentInfo)}

          <div className="row pt-2 padding-top-zero pl-4">
            <div className="col-12 zero-eight-em font-weight-bold pl-2">
              4. {CREDIT_CARD_AUTH_AGREEMENT}
            </div>
          </div>
          {this.renderCreditCardAuthAgreement()}

        </div>
      );
    } else {
      return(
        <div/>
      );
    }
  }

  private renderCreditCardAuthAgreement = (): JSX.Element => {
    return(
      <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
      <div className="col-12 black-border-transparent">
        <div className="row pa2">
          <div className="col-12 zero-six-em">
            <b>1.</b> I the Payor being the authorized cardholder, by signing below I understand and agree to the terms
            set forth in this agreement.&nbsp;
            <b>2.</b> I agree to pay and authorize Mimosa Solutions Inc. to charge my credit card for the amount 
            indicated above.&nbsp;
            <b>3.</b> I further agree that in the event my credit card becomes invalid, I will provide a new valid
            credit card to be charged for the payment of any outstanding balances owed.&nbsp;
            <b>4.</b> A service charge of <b className="red">$30.00 CDN</b> will be applied to all declined
            chrages.&nbsp;
            <b>5.</b> Charges made for actual services are non-refundable.&nbsp;
            <b>6.</b> In event of prepayment any unused funds will be refunded within 30 days.&nbsp;
            <b>7.</b> You may contact Mimosa Solutions Inc. at info@mimosa.solutions or the address noted to make
            any inquiries: 30 Wertheim Court Suite #12, Richmond Hill, ON, Canada, L4B 1B9, Telephone:
            (905) 597-5554 or Toll Free (833) 597-5554.&nbsp;

          </div>
        </div>
      </div>
    </div>
    );
  }

  private renderPaymentSchedule = (paymentInfo: PaymentInfo): JSX.Element => {
    return(
      <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
        <div className="col-12 black-border-transparent">
          <div className="row pa2">
            <div className="col-12 zero-eight-em">
              Total Payment due will be paid by the payor in&nbsp;
              <b className="blue">{paymentInfo.numberOfTransactions}</b>&nbsp;
              <b className="blue">{paymentInfo.term}</b> payment(s) of&nbsp;
              <b className="blue">
                <FormattedNumber value={paymentInfo.amountPerTransaction} style="currency" currency="USD" />
              </b>&nbsp;
              commencing on&nbsp;
              <b className="blue">
                {moment(new Date(paymentInfo.startDate)).format('MMM Do YY')}
              </b> and continuing until the
              total payment due has been paid in full.
            </div>
          </div>
        </div>
      </div>
    );
  }

  private renderPadAgreement = (): JSX.Element => {
    return(
      <div className="row pt-2 pl-4 pr-4 no-gutters padding-zero-row">
        <div className="col-12 black-border-transparent">
          <div className="row pa2">
            <div className="col-12 zero-eight-em">
              <b>1.</b>​In this Agreement, “I”, “me” and "my" refers to each Account Holder who signs below.&nbsp; 
              <b>2​.</b> I agree to participate in this Pre-Authorized Debit Plan and I authorize Mimosa Solutions Inc.
              the “Payee” and any successor or assign of the Payee to draw a debit in paper, electronic or other form
              for the purpose of making payment for consumer goods or services on my bank account indicated on our
              attached void cheque at the Financial Institution indicated on our attached void cheque and
              I authorize the Financial Institution to honour and pay such debits.&nbsp;
              <b>3​.</b> I may revoke or cancel this Agreement at any time upon (not to exceed 30 days) notice being
              provided by me in writing. I acknowledge that in order to revoke or cancel the authorization provided 
              in this Agreement, I must provide notice of revocation or cancellation to the Payee. This Agreement 
              applies only to the method of payment and I agree that revocation or cancellation of this Agreement 
              does not terminate or otherwise	have any bearing on any contract that exists between me and the Payee.
              &nbsp;
              <b>4.</b>​ We agree to either waive the requirement of receiving written notice from the Payee of the 
              amount(s) to be debited and the due date(s) of debiting, or to abide by any modification to the 
              requirement as agreed to with the Payee.&nbsp;
              <b>5.</b> I certify that all information provided with respect to the Account is accurate and I agree 
              to inform the Payee, in writing, of any change in the Account information provided in this Agreement 
              at least ten (10) business days prior to the next due date of a PAD. In the event of any such change, 
              this Agreement shall continue in respect of any new account to be used for PADs.&nbsp;
              <b>6​.</b> I agree to a service charge of THIRTY DOLLARS (<b className="red">$30.00 CDN</b>) CDN will 
              be applied to all insufficient cheques and declined credit cards.&nbsp;
              <b>7.</b> Recourse Rights: You have certain recourse rights if any PAD does not comply with this PAD 
              agreement. For example, you have the right to receive reimbursement for any PAD that is not authorized 
              or is not consistent with this agreement. To obtain more information on your recourse rights, you may 
              contact your financial institution or visit payments.ca.&nbsp;
              <b>8​.</b> You understand that you can contact Mimosa Solutions Inc. directly to make any inquiries, 
              obtain information or seek any recourse rights with respect to this PAD arrangement. Email 
              to: info@mimosa.solutions or by Mail to: 30 Wertheim Court Suite #12, Richmond Hill, L4B 1B9, ON, 
              Canada. Telephone: +1 (905) 597-5554 / Fax: +1 (905) 597-5525.&nbsp;
              <b>9.</b> Applicable to the Province of Quebec only:​ It is the express wish of the parties that this 
              authorization and any related documents be drawn up and	 executed in English. Les parties conviennent 
              que la présente autorisation et tous les documents s’y rattachant soient rédigés et signés en anglais.
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MembershipAgreementForm;



// WEBPACK FOOTER //
// ./src/members/MembershipAgreementComponent.tsx